import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProductReveal() {
  return <section className="px-6 py-10 max-w-5xl mx-auto" data-id="element-166">
      <FadeIn data-id="element-167">
        <div className="text-center mb-10" data-id="element-168">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-[#4A5D3A] mb-6" data-id="element-169">
            RESCATE HERBÁCEO S.O.S.
          </h1>
          <p className="text-xl md:text-2xl font-serif italic text-[#9B4F2B] max-w-3xl mx-auto leading-relaxed" data-id="element-170">
            El protocolo botánico de 15 minutos para cualquier mujer que
            necesita apagar el ruido mental ESTA noche — no en tres meses, no
            con receta, no con efectos secundarios.
          </p>
        </div>

        <div className="relative w-full max-w-3xl mx-auto mb-10 rounded-2xl overflow-hidden shadow-2xl" data-id="element-171">
          <img src="https://cdn.magicpatterns.com/uploads/hqDfq9WhQEb4HF8VDKWm61/MOCKUP.png" alt="Rescate Herbáceo S.O.S. Digital Product Bundle" className="w-full h-auto object-cover" data-id="element-172" />
        </div>

        <div className="max-w-3xl mx-auto space-y-4 text-lg md:text-xl text-center text-[#2D2A26]" data-id="element-173">
          <p className="text-[#9B4F2B] font-medium" data-id="element-174">
            No es un libro de teoría.
          </p>
          <p className="text-[#9B4F2B] font-medium" data-id="element-175">
            No es un recetario de abuela con fotos bonitas.
          </p>
          <p className="text-[#9B4F2B] font-medium" data-id="element-176">
            No es otro producto de "bienestar" que promete todo y entrega nada.
          </p>

          <div className="bg-[#4A5D3A]/5 p-6 md:p-10 rounded-3xl mt-8 border border-[#4A5D3A]/20" data-id="element-177">
            <p className="mb-6 leading-relaxed" data-id="element-178">
              Es una{' '}
              <strong className="text-[#4A5D3A]" data-id="element-179">
                guía táctica de acción inmediata
              </strong>{' '}
              construida alrededor de 3 plantas con respaldo científico,
              dosificadas de forma específica para enviarle a tu sistema
              nervioso la única señal que está esperando desde hace meses:
            </p>
            <h2 className="text-3xl md:text-4xl font-serif italic text-[#4A5D3A] font-bold" data-id="element-180">
              "Estamos a salvo. Ya puedes descansar."
            </h2>
          </div>
        </div>
      </FadeIn>
    </section>;
}